<div id="snapshotPdf" class="flex flex-col gap-2 f-s-12" style="max-width: 1000px; font-size: 12px; line-height: 1.5; word-wrap: break-word; overflow-wrap: break-word; word-break: break-word; zoom: reset; -webkit-text-size-adjust: 100%; -moz-text-size-adjust: 100%; text-size-adjust: 100%;">
  <div class="flex flex-col gap-2 w-1/2">
    <img src="assets/images/OHA-Color-Small.png" alt="OHA Logo">
  </div>
  <mat-card class="flex flex-col gap-2">
    <mat-card-title class="flex flex-col gap-2">
      <div><strong style="margin-right: 10px;">Service Center Name:</strong>{{data.entityName}}</div>
      <div><strong style="margin-right: 10px;">License Id:</strong>{{data.sB303.licenseId}}</div>
      <div><strong style="margin-right: 10px;">License Status:</strong>{{data.licenseStatus}}</div>
      <div><strong style="margin-right: 10px;">Approved Date:</strong>{{data.approvedDate | date}}</div>
      <div><strong style="margin-right: 10px;">Expiration Date:</strong>{{data.expirationDate | date}}</div>
      <div><strong style="margin-right: 10px;">Generated:</strong>{{currentDate | date:'short'}}</div>
    </mat-card-title>
  </mat-card>

  <!-- Client Data Reporting Information -->
  <mat-card class="flex flex-col gap-2">
    <mat-card-title style="font-size: 18px; font-weight: 600; margin-bottom: 8px;">303 Client Data</mat-card-title>
    <mat-card-content>
      <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
        <thead>
          <tr style="background-color: #f5f5f5;">
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd; font-weight: 600; width: 25%;">Submission Status</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd; font-weight: 600; width: 25%;">Date Submitted</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd; font-weight: 600; width: 25%;">Submitted By</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd; font-weight: 600; width: 25%;">Quarter Indicator</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd; font-weight: 600; width: 25%;">Reporting Window Open Date</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd; font-weight: 600; width: 25%;">Reporting Window Close Date</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="padding: 8px; border: 1px solid #ddd;">{{data.sB303.clientData.submitted ? 'Submitted' : 'Not Submitted'}}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">{{(data.sB303.clientData.submittedDate | date:'short')}}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">{{data.sB303.clientData.submittedBy}}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">
              <span class="flex flex-col gap-1">
                <span *ngIf="data.sB303.clientData.partialQuarter">Partial Quarter</span>
                <span *ngIf="!data.sB303.clientData.partialQuarter">Full Quarter</span>
                <span *ngIf="data.sB303.clientData.partialQuarter">{{ data.sB303.clientData.lastClientDate | date }}</span>
              </span>
            </td>
            <td style="padding: 8px; border: 1px solid #ddd;">{{data.sB303.reportingStartDate | date}}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">{{data.sB303.reportingEndDate | date}}</td>
          </tr>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>

  <!-- Client Data Notes -->
  <mat-card class="flex flex-col gap-2" *ngIf="data.clientDataNotes && data.clientDataNotes.length > 0">
    <mat-card-title style="font-size: 18px; font-weight: 600; margin-bottom: 8px;">303 Client Data Notes</mat-card-title>
    <mat-card-content>
      <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
        <thead>
          <tr style="background-color: #f5f5f5;">
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd; font-weight: 600; width: 15%;">Date Created</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd; font-weight: 600; width: 15%;">Created By</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd; font-weight: 600; width: 70%;">Note</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let note of data.clientDataNotes">
            <td style="padding: 8px; border: 1px solid #ddd;">{{note.dateCreated}}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">{{note.createdBy}}</td>
            <td style="padding: 8px; border: 1px solid #ddd; white-space: pre-wrap;">{{note.text}}</td>
          </tr>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>

  <!-- Service Center Data Reporting Information -->
  <mat-card class="flex flex-col gap-2">
    <mat-card-title style="font-size: 18px; font-weight: 600; margin-bottom: 8px;">303 Service Center Data</mat-card-title>
    <mat-card-content>
      <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
        <thead>
          <tr style="background-color: #f5f5f5;">
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd; font-weight: 600; width: 25%;">Submission Status</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd; font-weight: 600; width: 25%;">Date Submitted</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd; font-weight: 600; width: 25%;">Submitted By</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd; font-weight: 600; width: 25%;">Quarter Indicator</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd; font-weight: 600; width: 25%;">Reporting Window Open Date</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd; font-weight: 600; width: 25%;">Reporting Window Close Date</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="padding: 8px; border: 1px solid #ddd;">{{data.sB303.serviceCenterData.submitted ? 'Submitted' : 'Not Submitted'}}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">{{(data.sB303.serviceCenterData.submittedDate | date:'short')}}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">{{data.sB303.serviceCenterData.submittedBy}}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">
              <span class="flex flex-col gap-1">
                <span *ngIf="data.sB303.serviceCenterData.partialQuarter">Partial Quarter</span>
                <span *ngIf="!data.sB303.serviceCenterData.partialQuarter">Full Quarter</span>
                <span *ngIf="data.sB303.serviceCenterData.partialQuarter">{{ data.sB303.serviceCenterData.lastClientDate | date }}</span>
              </span>
            </td>
            <td style="padding: 8px; border: 1px solid #ddd;">{{data.sB303.reportingStartDate | date}}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">{{data.sB303.reportingEndDate | date}}</td>
          </tr>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>

  <!-- Service Center Data Notes -->
  <mat-card class="flex flex-col gap-2" *ngIf="data.serviceCenterDataNotes && data.serviceCenterDataNotes.length > 0">
    <mat-card-title style="font-size: 18px; font-weight: 600; margin-bottom: 8px;">303 Service Center Data Notes</mat-card-title>
    <mat-card-content>
      <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
        <thead>
          <tr style="background-color: #f5f5f5;">
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd; font-weight: 600; width: 15%;">Date Created</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd; font-weight: 600; width: 15%;">Created By</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd; font-weight: 600; width: 70%;">Note</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let note of data.serviceCenterDataNotes">
            <td style="padding: 8px; border: 1px solid #ddd;">{{note.dateCreated}}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">{{note.createdBy}}</td>
            <td style="padding: 8px; border: 1px solid #ddd; white-space: pre-wrap;">{{note.text}}</td>
          </tr>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>

</div>
